import { Component } from '@angular/core';
import { ModalController } from 'ionic-angular';
import { Router } from '@angular/router';

import { AdminService } from '../../services/admin.service';
import { AdminKeypadPage } from '../../pages/admin-keypad/admin-keypad';

@Component({
  selector: 'zeiss-logo',
  templateUrl: './zeiss-logo.html'
})

export class ZeissLogoComponent {

  constructor(
    private router: Router,
    public modalCtrl: ModalController,
    public adminService: AdminService
  ) { }

  openSuperSecretAdminKeypad(): void {
    this.adminService.resetValidPin();
    const adminKeypadModal = this.modalCtrl.create(AdminKeypadPage, {}, {cssClass: 'keypad-modal'});
    adminKeypadModal.present();
    adminKeypadModal.onDidDismiss((res: boolean) => {
      if (res) {
        this.router.navigate(['admin-settings']);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/components/zeiss-logo/zeiss-logo.component.ts